/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Box,
  Button,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import { AnexoPreviewV2, DialogDefaultV2, TableV2 } from '../../../components/v2';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsAportes from '../../../store/aporte/reducer';
import * as actionsAportes from '../../../store/aporte/actions';
import { findFotoById } from '../../../store/nota/actions';
import * as Role from '../../../constants/role';
import Formulario from './Formulario';
import FormularioNota from '../Notas/Formulario';

const AporteUsuarioV2 = ({
  aporteByUsuario,
  loadAportesByInspetor,
  userRole,
  findAporteFotosById,
  match,
  history,
  findFotoById,
}) => {
  const [open, setOpen] = useState(false);
  const [openNota, setOpenNota] = useState(false);
  const [id, setId] = useState(null);
  const [idNota, setIdNota] = useState(null);
  const [usuarioId, setUsuarioId] = useState(null);
  const [openNotFotoModal, setOpenNotFotoModal] = useState(false);
  const [openAnexoPreview, setOpenAnexoPreview] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [aporteByUsuarioLocal, setAporteByUsuarioLocal] = useState({});

  useEffect(() => {
    if (match && match.params && match.params.usuarioId) {
      setUsuarioId(match.params.usuarioId);
    }
  }, [match]);

  useEffect(() => {
    if (aporteByUsuario) setAporteByUsuarioLocal(aporteByUsuario);
  }, [aporteByUsuario]);

  useEffect(() => {
    loadAportesByInspetor({ usuarioId: match.params.usuarioId });
  }, [usuarioId]);

  const isAdmin = () => Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole;

  const onEdit = (rowId) => {
    const currentRow = aporteByUsuarioLocal.aportes?.find((s) => s.id === rowId);
    if (currentRow?.isAporte) {
      setOpen(true);
      setId(rowId);
    } else {
      setOpenNota(true);
      setIdNota(rowId);
    }
  };

  const onAdd = () => {
    setOpen(true);
    setId(null);
    setIdNota(null);
  };

  const onClose = (isSave) => {
    if (isSave) {
      loadAportesByInspetor({ usuarioId: match.params.usuarioId });
    }
    setOpen(false);
    setOpenNota(false);
    setId(null);
    setIdNota(null);
  };

  const headerActions = [];
  if (isAdmin()) {
    headerActions.push({
      label: 'Novo',
      onClick: onAdd,
      startIcon: <AddIcon />,
      variant: 'contained',
    });
  }

  const rowActions = [
    {
      key: 'view-foto',
      icon: <CameraAltOutlinedIcon fontSize="small" />,
      title: 'Ver anexo',
      onClick: (rowId) => {
        const currentRow = aporteByUsuarioLocal.aportes?.find((s) => s.id === rowId);
        if (currentRow?.isAporte) {
          findAporteFotosById(rowId, (files) => {
            if (files && files.length > 0) {
              setAttachments(files);
              setOpenAnexoPreview(true);
            } else {
              setOpenNotFotoModal(true);
            }
          });
        } else {
          findFotoById(rowId, (files) => {
            if (files && files.length > 0) {
              setAttachments(files);
              setOpenAnexoPreview(true);
            } else {
              setOpenNotFotoModal(true);
            }
          });
        }
      },
    },
  ];

  const valorBalanco = aporteByUsuarioLocal.valor;
  const isNegativo = valorBalanco != null && valorBalanco < 0;

  return (
    <Box>
      <Stack spacing={3}>
        {isAdmin() && (
          <Box sx={{ pr: 2 }}>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              onClick={() => history.goBack()}
              sx={{ fontSize: 12 }}
            >
              Voltar
            </Button>
          </Box>
        )}

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Aportes - Entrada e Saída</Typography>
        </Stack>

        <Stack spacing={0.5} sx={{ px: 1 }}>
          <Typography variant="body1">
            <strong>Usuário:</strong> {aporteByUsuarioLocal.usuarioName}
          </Typography>
          <Typography variant="body1">
            <strong>Balanço:</strong>{' '}
            <Typography
              component="span"
              sx={{
                color: isNegativo ? 'error.main' : 'success.main',
                fontWeight: 600,
              }}
            >
              {valorBalanco != null
                ? valorBalanco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                : '-'}
            </Typography>
          </Typography>
          <Typography variant="body1">
            <strong>Data do Último Aporte:</strong>{' '}
            {aporteByUsuarioLocal.dataUltimoAporte
              ? moment(Number(aporteByUsuarioLocal.dataUltimoAporte)).format('DD/MM/YYYY')
              : '-'}
          </Typography>
          <Typography variant="body1">
            <strong>Data do Último Gasto:</strong>{' '}
            {aporteByUsuarioLocal.dataUltimoGasto
              ? moment(Number(aporteByUsuarioLocal.dataUltimoGasto)).format('DD/MM/YYYY')
              : '-'}
          </Typography>
        </Stack>

        <TableV2
          rows={aporteByUsuarioLocal?.aportes || []}
          rowHeight={56}
          headerActions={headerActions}
          actions={rowActions}
          columns={[
            {
              field: 'isAporte',
              headerName: '',
              width: 50,
              renderCell: ({ row }) => (
                <MonetizationOnIcon sx={{ color: row.background }} />
              ),
            },
            {
              field: 'dataTimestamp',
              headerName: 'Data',
              width: 140,
              renderCell: ({ row }) =>
                moment(Number(row.dataTimestamp)).format('DD/MM/YYYY'),
            },
            {
              field: 'valor',
              headerName: 'Valor',
              width: 160,
              renderCell: ({ row }) =>
                row.valor != null
                  ? row.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                  : '—',
            },
            {
              field: 'inspetorName',
              headerName: 'Usuário',
              flex: 1,
              minWidth: 200,
            },
          ]}
          onEdit={onEdit}
          canDelete={() => false}
        />

        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          isAdmin={isAdmin()}
          inspetorId={usuarioId}
          isEdit={!!id}
        />

        <FormularioNota
          id={idNota}
          open={openNota}
          onClose={onClose}
          isAdmin={isAdmin()}
        />
      </Stack>

      <AnexoPreviewV2
        open={openAnexoPreview}
        onClose={() => {
          setOpenAnexoPreview(false);
          setAttachments([]);
        }}
        attachments={attachments}
        title="Anexos do aporte"
      />

      <DialogDefaultV2
        open={openNotFotoModal}
        handlerCancel={() => setOpenNotFotoModal(false)}
        readOnly
      >
        <DialogContentText>Aporte não possui foto</DialogContentText>
      </DialogDefaultV2>
    </Box>
  );
};

AporteUsuarioV2.propTypes = {
  deleteAporte: PropTypes.func,
  loadAportesByInspetor: PropTypes.func.isRequired,
  aporteByUsuario: PropTypes.object,
  userRole: PropTypes.string.isRequired,
  findAporteFotosById: PropTypes.func.isRequired,
  findFotoById: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userRole: selectorsAuth.getRole(state),
  aporteByUsuario: selectorsAportes.getAporteByUsuario(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsAportes,
      findFotoById,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AporteUsuarioV2));
